import moment from "moment";

export const isUnloadingActionRequired = (item, now = moment()) => {
  if (item?.status !== "onthetrip" || !item?.expectedUnloadingDate) {
    return false;
  }

  const expectedDate = moment(item.expectedUnloadingDate, moment.ISO_8601, true);
  const currentDate = moment(now);

  return expectedDate.isValid() && currentDate.isValid() && expectedDate.isBefore(currentDate, "day");
};
